"use client";

import { createUsePuck } from "@puckeditor/core";
import { LandingThemePicker } from "@/components/admin/landings/landing-theme-picker";
import { parseRootTheme } from "@/lib/landing/puck/themes";
import type { LandingPuckData } from "@/lib/landing/puck/types";

const usePuckStore = createUsePuck();

export function LandingPuckThemeField() {
  const data = usePuckStore((s) => s.appState.data as LandingPuckData);
  const dispatch = usePuckStore((s) => s.dispatch);

  const theme = parseRootTheme(data.root?.props as Record<string, unknown>);

  return (
    <LandingThemePicker
      mode="sidebar"
      value={{
        accentPalette: theme.accentPalette,
        surfaceLight: theme.surfaceLight,
        surfaceDark: theme.surfaceDark,
        colorScheme: theme.colorScheme,
      }}
      onChange={(next) => {
        dispatch({
          type: "setData",
          data: {
            ...data,
            root: {
              ...data.root,
              props: {
                ...data.root.props,
                ...next,
              },
            },
          },
        });
      }}
    />
  );
}
